<template>
  <div>
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card
        class="rounded-lg"
        style="display: flex; flex-direction: column; height: 100%"
      >
        <v-card-title
          style="
            background-color: #000000 !important;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: white;
          "
        >
          <div>
            <span
              class="font-weight-bold text-h6"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
              >{{ main_title }}</span
            >
            <div
              class="text-caption"
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              {{ sub_title }}
            </div>
          </div>
          <v-btn
            :disabled="loading"
            flat
            icon
            color="primary"
            @click="closeDialog()"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="overflow-y: auto; max-height: calc(100vh - 200px)">
          <v-form ref="form" class="mt-4">
            <v-row
              dense
              style="
                font-family:
                  Saira Condensed,
                  sans-serif;
              "
            >
              <v-col cols="12">
                <div class="font-weight-bold" style="color: red">
                  {{ $t("GuessTheBalance.Labels.Note") }}:
                  <span class="font-weight-regular">
                    {{ $t("GuessTheBalance.Dialogs.Ending.WarningNote") }}
                  </span>
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="endingBalancePrize"
                  :rules="[
                    (v) =>
                      (v !== '' && v >= 0) ||
                      $t('GuessTheBalance.Validation.ValueCannotBeNegative'),
                  ]"
                  :label="$t('GuessTheBalance.Fields.GTBPrize')"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  style="
                    font-family:
                      Saira Condensed,
                      sans-serif;
                  "
                ></v-text-field>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="gthpPrize"
                  :rules="[
                    (v) =>
                      (v !== '' && v >= 0) ||
                      $t('GuessTheBalance.Validation.ValueCannotBeNegative'),
                  ]"
                  :label="$t('GuessTheBalance.Fields.GTHPPrize')"
                  type="number"
                  variant="outlined"
                  density="comfortable"
                  color="primary"
                  style="
                    font-family:
                      Saira Condensed,
                      sans-serif;
                  "
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-3" style="margin-top: auto">
          <v-spacer></v-spacer>
          <v-btn
            class="mr-1 text-subtitle-1"
            :disabled="loading"
            :text="$t('Buttons.Cancel')"
            variant="outlined"
            elevation="1"
            @click="closeDialog()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          ></v-btn>
          <v-btn
            class="mr-1 text-subtitle-1"
            :loading="loading"
            :text="$t('Buttons.Save')"
            variant="elevated"
            elevation="1"
            color="primary"
            @click="validateForm()"
            style="
              font-family:
                Saira Condensed,
                sans-serif;
            "
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar"
      :timeout="2500"
      :color="snackColor"
      location="top"
    >
      <v-icon>mdi-alert-circle</v-icon>
      <span
        class="ml-2"
        style="
          font-family:
            Saira Condensed,
            sans-serif;
        "
        >{{ snackText }}</span
      >
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  emits: ["refresh"],
  data() {
    return {
      dialog: false,
      main_title: null,
      sub_title: null,
      action: null,
      loading: false,

      snackbar: false,
      snackText: null,
      snackColor: null,

      gtbId: null,
      endingBalancePrize: null,
      gthpPrize: null,

      formRules: {
        required: (value) => !!value || this.$t("FormRules.Required"),
        minValue: (value) =>
          (value && value != 0) ||
          this.$t("GuessTheBalance.Validation.MustBeGreaterThanZero"),
        maxLength: (value) =>
          (value && value.toString().length >= 8) ||
          this.$t("GuessTheBalance.Validation.MustBeAtMost8Chars"),
        noSpacesOnly: (value) =>
          (value && value.trim().length > 0) ||
          this.$t("GuessTheBalance.Validation.CannotBeOnlySpaces"),
      },
    };
  },
  methods: {
    initEnd(data) {
      this.dialog = true;
      this.main_title = this.$t("GuessTheBalance.Dialogs.Ending.Title");
      this.sub_title = this.$t("GuessTheBalance.Dialogs.Ending.Subtitle");

      this.gtbId = data._id;
    },
    async validateForm() {
      const { valid } = await this.$refs.form.validate();

      if (valid) {
        const token = localStorage.getItem("abughazi-admin-accesstoken");

        let formData = {
          prize: parseInt(this.endingBalancePrize),
          gthpPrize: parseInt(this.gthpPrize),
        };

        this.loading = true;
        axios
          .post(
            process.env.VUE_APP_SERVER_URL +
              `/api/admin/guess-the-balance/end/${this.gtbId}`,
            formData,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "x-admin-key": process.env.VUE_APP_X_ADMIN_KEY,
              },
            },
          )
          .then((res) => {
            if (res.data) {
              this.$emit("refresh");
              this.loading = false;
              this.snackText = this.$t(
                "GuessTheBalance.Messages.EndedSuccessfully",
              );
              this.snackbar = true;
              this.snackColor = "green";
              this.$refs.form.reset();
              this.dialog = false;
            }
          })
          .catch((error) => {
            if (error.response) {
              if (error.response.status === 401) {
                localStorage.removeItem("vuex");
                localStorage.removeItem("abughazi-admin-accesstoken");
                window.location.reload();
              } else {
                this.snackText =
                  error.response.data.message ||
                  this.$t("GuessTheBalance.Messages.SomethingWentWrong");
                this.snackbar = true;
                this.snackColor = "secondary";
                this.loading = false;
              }
            } else if (error.request) {
              console.log("No response received", error.request);
            } else {
              console.log("Error", error.message);
            }
          });
      }
    },
    closeDialog() {
      this.$refs.form.reset();
      this.dialog = false;
    },
  },
});
</script>

<style scoped></style>
